import { WithSubMenus } from "../components"
import { AllPlates, Dropboxes, MakeRun, PlateDetails, PlateEditor, Promotions, Quotes, UserDetails, Unsubscribes, MakeInvoice, DeleteInvoice, Invoices, EditInvoice, Tools, GpuServer, MinKnow, FlowCells, FlowCellEdit } from "../pages"
import { AllRuns } from "../pages/AllRuns"
import { AdminOrderDetail, AllOrders, CompareOrderResults, EditOrderResult } from "../pages/order"
import RunDetails from "../pages/RunDetails"
import { Users, UserGroups, UserGroupDetails } from "../pages/user"

import { ProtectedRoute } from "./ProtectedRoute"

export const adminRoutes = [
  {
    path: "admin/orders",
    element: (
        <ProtectedRoute permission="admin,scientist">
          <WithSubMenus key={Math.random()}>
            <AllOrders />
          </WithSubMenus>
        </ProtectedRoute>
    ),
  },
  {
    path: "admin/users",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <Users />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/usergroups",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <UserGroups />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/user/:userId",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <UserDetails />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/usergroup/:groupId",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <UserGroupDetails />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  { 
    path: "admin/order/:orderId",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <AdminOrderDetail />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/orderresult/:orderResultId/edit",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <EditOrderResult />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/order/:orderId/compare-results",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <CompareOrderResults />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/makeinvoice",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <MakeInvoice />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/deleteinvoice",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <DeleteInvoice />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/invoices",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <Invoices />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/invoice/edit/:invoiceId",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <EditInvoice />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/editplate",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <PlateEditor />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/plates",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <AllPlates />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/plate/:plateId",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <PlateDetails />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/runs",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <AllRuns />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/run/:runId",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <RunDetails />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/makerun",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <MakeRun />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/promotions",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <Promotions />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/unsubscribes",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <Unsubscribes />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/quotes",
    element: (
      <ProtectedRoute permission="admin">
        <WithSubMenus>
          <Quotes />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/dropboxes",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <Dropboxes />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/tools",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <Tools />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/gpu",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <GpuServer />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/minknow",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <MinKnow />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/flowcell/:flowCellId",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <FlowCellEdit />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/flowcells",
    element: (
      <ProtectedRoute permission="admin,scientist">
        <WithSubMenus>
          <FlowCells />
        </WithSubMenus>
      </ProtectedRoute>
    ),
  },
]
